import createStore from '../../../redux/factories/crud/crudFactory';

export const apiKey = createStore('api/v2/apikey');
export const subscription = createStore('api/v2/subscriptions');
export const billing = createStore('api/v2/billing');

